import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: '2FA Protected',
      description: 'Two-factor authentication'
    },
    {
      icon: 'Eye',
      title: 'Privacy First',
      description: 'Your data is secure'
    },
    {
      icon: 'Zap',
      title: 'Real-time Data',
      description: 'Live market feeds'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-2">Trusted by Traders</h3>
        <p className="text-sm text-muted-foreground">
          Join thousands of professionals using our secure platform
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="bg-muted/50 rounded-lg p-4 text-center border border-border/50"
          >
            <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-2">
              <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
            </div>
            <h4 className="text-sm font-medium text-foreground mb-1">{feature?.title}</h4>
            <p className="text-xs text-muted-foreground">{feature?.description}</p>
          </div>
        ))}
      </div>
      {/* Trust Indicators */}
      <div className="bg-card border border-border rounded-lg p-4">
        <div className="flex items-center justify-center space-x-4 mb-3">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full"></div>
            <span className="text-xs text-muted-foreground">99.9% Uptime</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full"></div>
            <span className="text-xs text-muted-foreground">24/7 Support</span>
          </div>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            Regulated and compliant with industry standards
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;